module.exports = __webpack_public_path__ + "img/logo-white.533688b6.svg";